/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Diet_TitleInputs */

const en_portal_view_diet_title = /** @type {(inputs: Portal_View_Diet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet`)
};

const pl_portal_view_diet_title = /** @type {(inputs: Portal_View_Diet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta`)
};

/**
* | output |
* | --- |
* | "Diet" |
*
* @param {Portal_View_Diet_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_diet_title = /** @type {((inputs?: Portal_View_Diet_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Diet_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_diet_title(inputs)
	return en_portal_view_diet_title(inputs)
});